import React from 'react';
import { Typography } from '@/components/common';
import { SignReviewComparison } from '@/interfaces';
import { ReviewMismatchBanner } from './ReviewMismatchBanner';
import { ReviewFieldRow } from './ReviewFieldRow';
import { SignatureField } from './SignatureField';

interface Props {
	comparison: SignReviewComparison;
}

export const DataProvidedCard: React.FC<Props> = ({ comparison }) => {
	const { fields, signature, mismatchedLabels, isComparisonAvailable } =
		comparison;

	return (
		<div className="border border-grey-100 rounded-2xl p-4 flex flex-col gap-4 h-full min-h-0">
			<Typography type="semibold-14" className="text-left shrink-0">
				Data provided in the document
			</Typography>
			<div className="flex-1 min-h-0 overflow-y-auto scroll-custom flex flex-col gap-4">
				{isComparisonAvailable && (
					<ReviewMismatchBanner mismatchedLabels={mismatchedLabels} />
				)}
				{fields.length > 0 && (
					<div className="flex flex-col gap-3">
						{fields.map((field) => (
							<ReviewFieldRow
								key={field.id}
								label={field.label}
								value={field.submittedValue}
								status={field.status}
							/>
						))}
					</div>
				)}
				{signature && <SignatureField signature={signature} />}
			</div>
		</div>
	);
};
